import { CurrentUnits } from "@/libs/units/current";
import { PercentageUnits } from "@/libs/units/percentage";
import { PowerUnits } from "@/libs/units/power";
import { TemperatureUnits } from "@/libs/units/temperature";
import { VoltageUnits } from "@/libs/units/voltage";
import { EquipmentCalculatorSectionKey } from "../../calculationTypes";
import type { Section, SectionDeps } from "../types";
import { ScenarioDetailSectionKey, ScenarioDetailSectionTitle } from "../types";

export const buildMleSideCalculatorSection = ({
  scenarioCalculations,
  getRealPowerUnit
}: SectionDeps): Section => ({
  id: EquipmentCalculatorSectionKey.MLE,
  hash: ScenarioDetailSectionKey.SEAL_SENSOR_MLE,
  label: ScenarioDetailSectionTitle.MLE,
  routeName: "SizingParameters",
  aggregateDisplays: [
    {
      label: "Average Ambient Temperature",
      base: TemperatureUnits.Fahrenheit,
      model: TemperatureUnits.options(),
      value:
        scenarioCalculations.motorLeadExtensionCalculations.mleCableData.value
          .averageAmbientTemperatureF,
      mode: "convert"
    },
    {
      label: "Cable Temperature",
      base: TemperatureUnits.Fahrenheit,
      model: TemperatureUnits.options(),
      value:
        scenarioCalculations.motorLeadExtensionCalculations.mleCableData.value
          .cableMaxTemperatureF,
      mode: "convert"
    },
    {
      label: "Cable Load",
      base: PercentageUnits.Ratio,
      target: PercentageUnits.Percentage,
      model: PercentageUnits.options(),
      mode: "read",
      value:
        scenarioCalculations.motorLeadExtensionCalculations.mleCableData.value
          .cableMotorLoadRatio
    },
    {
      label: "Max Amps at Temp",
      base: CurrentUnits.Amperes,
      model: [CurrentUnits.Amperes],
      value:
        scenarioCalculations.motorLeadExtensionCalculations.mleCableData.value
          .maxAmpsAtMaxTemperatureA,
      mode: "read"
    },
    {
      label: "MLE Voltage Loss",
      base: VoltageUnits.Volts,
      model: VoltageUnits.options(),
      mode: "convert",
      value:
        scenarioCalculations.motorLeadExtensionCalculations.mleCableData.value
          .totalVoltLossV
    },
    {
      label: "MLE Power Loss",
      base: PowerUnits.KiloWatts,
      target: getRealPowerUnit().value,
      model: PowerUnits.options(),
      mode: "read",
      value:
        scenarioCalculations.motorLeadExtensionCalculations.mleCableData.value
          .powerLossKW
    }
  ]
});
